<template>
  <v-container fluid fill-height>
        <v-layout justify-center align-center>
          <v-progress-circular indeterminate color="primary"
          :size="40"
          :width="3"
          
          ></v-progress-circular>
        </v-layout>
      </v-container>
</template>

<style>
    .loading-dialog {
   background-color: transparent; 
   opacity: 0.2;
}
</style>

<script>
  export default {
    data () {
      return {
        // dialog: true
      }
    
    }
    // , 
    // props: ['isloading'],
  }
</script>